/**
 * Builds a config document out of environment variables, for runtimes that have no document on
 * disk: the browser, which reads the variables Nuxt bakes into `runtimeConfig.public`, and the
 * build-time processes that read them from `.secrets`.
 *
 * Only string-valued keys can travel this way. Structured keys like `DATABASE_CONFIG` belong to
 * deployed runtimes, which are packaged with a real document instead.
 */
export function createEnvRuntimeConfig(env) {
    const config = {};
    for (const [key, value] of Object.entries(env)) {
        if (value !== undefined) {
            config[key] = value;
        }
    }
    return config;
}
//# sourceMappingURL=createEnvRuntimeConfig.js.map